import React from "react";
import { Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const { Text } = Typography;

const LargeLoadingIcon = () => <LoadingOutlined style={{ fontSize: 48, color: "#1890ff" }} spin />;
const spinnerStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  zIndex: 9999,
};
const messageStyle = {
  marginTop: "16px",
  fontSize: "18px",
  color: "#555",
};

const Loader = ({ message }) => {
  return (
    <div style={spinnerStyle}>
      <Spin indicator={<LargeLoadingIcon />} />
      <div style={messageStyle}>{message}</div>
    </div>
  );
};

export default Loader;
